import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Contact.css';
import { motion } from 'framer-motion';
import Contactbg from '../Assets/Contactbg.png';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Handle input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle form submission
  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const controller = new AbortController();

      const timeoutId = setTimeout(() => {
        controller.abort();
      }, 15000);

      const response = await fetch('/contact_handler.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      const text = await response.text();
      console.log('Raw contact response:', text);

      let result;

      try {
        result = JSON.parse(text);
      } catch {
        throw new Error('The server did not return valid JSON.');
      }

      if (!response.ok) {
        throw new Error(result.message || `Server error: ${response.status}`);
      }

      if (result.success) {
        setSuccessMessage('✅ Your message has been sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setErrorMessage(result.message || '❌ Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Submission error:', error);

      if (error.name === 'AbortError') {
        setErrorMessage('❌ The request timed out. The email server may not be responding.');
      } else {
        setErrorMessage(`❌ ${error.message || 'Network error. Please try again later.'}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="contact"
      style={{
        backgroundImage: `
      linear-gradient(
        rgba(15,23,42,0.78),
        rgba(15,23,42,0.82)
      ),
      url(${Contactbg})
    `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >      {/* Animated Background + Navbar */}
      <Navbar />


      {/* Contact Section */}
      <div className="contact-page">
        <motion.div
          className="contact-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Contact Info */}
          <div className="contact-info">
            <h1 className="contact-title">Get in touch</h1>
            <p className="contact-subtitle">
              Request a demo, ask about federal contracts, or inquire about our AI solutions.
            </p>
          </div>

          {/* Contact Form */}
          <form className="contact-form" onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                aria-label="Your name"
                placeholder="Your name"
                required
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                aria-label="Your email"
                placeholder="Your email address"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                aria-label="Your message"
                placeholder="Your message"
                rows={5}
                required
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            {/* Feedback messages */}
            {successMessage && <motion.p className="success-message" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>{successMessage}</motion.p>}
            {errorMessage && <motion.p className="error-message" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>{errorMessage}</motion.p>}

            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </motion.div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Contact;